<template>
  <m-dialog ref="registrasiDlg" :ready="!is_daftar && !guruSelectionError" :isclose="true" @save="save" :fullscreen="true" title="Pendaftaran Seri TPSD">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="12" md="10" lg="8">
          <!-- Konten Kolom 1 -->
          <v-card>
            <v-card-title>Formulir Pendaftaran Seri {{ current_instansi.nama }}</v-card-title>
            <p class="mx-4">
              Pada seri {{ current_instansi.nama }}, setiap Jenjang memiliki kebutuhan kelompok yang berbeda.<br />
              <ol>
                <li><strong>Jenjang PAUD</strong> kelompok terdiri dari <strong>1 Kepala Sekolah dan maksimal 2 Guru</strong></li>
              <li>
                <strong>Jenjang SD</strong> hanya dapat diikuti oleh guru kelas 1 dan 2 dengan maksimal 2 guru
                <strong>maksimal 2 Guru</strong>
              </li>
                <li>Semua peserta yang terdaftar wajib mentautkan akun dengan email <strong>belajar.id</strong></li>
              </ol>

            </p>
            <v-alert  prominent v-if="is_daftar" icon="mdi-information" text type="info" class="ma-4">
              <span class="black--text text-sm">Sekolah Anda telah terdaftar di Seri TPSD dengan formasi peserta dibawah ini</span>
            </v-alert>
            <v-card-text>
              <v-form @submit.prevent data-vv-scope="form" lazy-validation>
                <v-row dense>
                  <v-col cols="12" v-if="sekolah.jenjang_id !== 2">
                    <v-text-field outlined dense label="Kepala Sekolah" v-model="grup.leader" disabled hide-details></v-text-field>
                    <div v-if="grup.leader && sekolah.jenjang_id !== 2" :class="isBelajarIdLeader ? 'text-small green--text pb-4' : 'text-small orange--text pb-4'">
                      <v-icon size="16" left :class="isBelajarIdLeader ? 'green--text' : 'orange--text'">
                        {{ isBelajarIdLeader ? "mdi-check-circle" : "mdi-information" }}
                      </v-icon>
                      {{ isBelajarIdLeader ? "Sudah mentautkan akun ke email belajar.id" : "Belum mentautkan akun ke belajar.id" }}
                    </div>
                    <div v-else>
                      <span class="text-small orange--text text-caption">Untuk jenjang SD Kepala Sekolah hanya dapat mendaftarkan 2 Guru</span>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :disabled="is_daftar"
                      clearable
                      @change="validateGuruSelection(grup.user1,1)"
                      dense
                      outlined
                      v-model="grup.user1"
                      :items="itemKandidats"
                      label="Pilih Guru 1"
                      item-text="nama"
                      item-value="ptk_id"
                      return-object
                      hide-details
                      no-data-text="Tidak ada data PTK yang tersedia"
                    >
                      <template v-slot:selection="{ item }">
                        <span
                          >{{ item.nama }} ({{item.no_ukg}})
                          <span v-if="item.email_belajar" class="grey--text">
                            {{ item.email_belajar ? item.email_belajar : "Belum mentautkan belajar.id" }}
                          </span>
                        </span>
                      </template>
                    </v-select>
                    <div v-if="grup.user1" :class="isEmailBelajarUser1 ? 'text-small green--text pb-4' : 'text-small orange--text pb-4'">
                      <v-icon size="16" left :class="isEmailBelajarUser1 ? 'green--text' : 'orange--text'">
                        {{ isEmailBelajarUser1 ? "mdi-check-circle" : "mdi-information" }}
                      </v-icon>
                      {{ isEmailBelajarUser1 ? "Sudah mentautkan akun ke email belajar.id" : "Belum mentautkan akun ke belajar.id" }}
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :disabled="is_daftar"
                      clearable
                      @change="validateGuruSelection(grup.user2,2)"
                      dense
                      outlined
                      v-model="grup.user2"
                      :items="itemKandidats"
                      label="Pilih Guru 2"
                      item-text="nama"
                      item-value="ptk_id"
                      return-object
                      hide-details
                      no-data-text="Tidak ada data PTK yang tersedia"
                    >
                      <template v-slot:selection="{ item }">
                         <span
                         >{{ item.nama }} ({{item.no_ukg}})
                          <span v-if="item.email_belajar" class="grey--text">
                            {{ item.email_belajar ? item.email_belajar : "Belum mentautkan belajar.id" }}
                          </span>
                        </span>
                      </template>
                    </v-select>
                    <div v-if="grup.user2" :class="isEmailBelajarUser2 ? 'text-small green--text pb-4' : 'text-small orange--text pb-4'">
                      <v-icon size="16" left :class="isEmailBelajarUser2 ? 'green--text' : 'orange--text'">
                        {{ isEmailBelajarUser2 ? "mdi-check-circle" : "mdi-information" }}
                      </v-icon>
                      {{ isEmailBelajarUser2 ? "Sudah mentautkan akun ke email belajar.id" : "Belum mentautkan akun ke belajar.id" }}
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-alert prominent dense class="mt-6 mx-2" icon="mdi-information" text type="info">
                <v-row align="center" class="black--text">
                  <v-col class="grow">
                    Jika akun anda belum dilakukan
                    penautan akun maka silahkan dilakukan penautan ke <a href="https://pusatinformasi.belajar.id/hc/id/articles/5696645239961-Panduan-Menautkan-Akun-belajar-id-Setelah-Login-Pada-Akun-SIMPKB" target="_blank">belajar.id</a>
                  </v-col>
                </v-row>
              </v-alert>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- Dialog Konfirmasi -->
    <v-dialog v-model="showConfirmationDialog" max-width="600">
      <v-card>
        <v-card-title>{{grup.isSyaratComplete?'Konfirmasi Pendaftaran':'Konfirmasi Pendaftaran'}}</v-card-title>
        <v-divider class="py-4"></v-divider>
        <v-card-text>
          <v-row v-if="grup.isSyaratComplete&&isNotAvailableClass">
            <v-col class="shrink"><v-icon left class="green--text" size="45">mdi-check-circle</v-icon></v-col>
            <v-col class="grow"><p>Semua Persyaratan Anggota telah <strong class="green--text font-weight-medium">terpenuhi</strong>. Jika Anda yakin tidak akan ada perubahan pada anggota yang terdaftar, Anda bisa melanjutkan klik tombol Daftar.</p>
            <p>Sebagai informasi bahwa setelah mendaftar, data yang sudah Anda kirim tidak dapat diubah kembali</p>
              <p>Terima Kasih</p>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col class="shrink"><v-icon left class="orange--text" size="45">mdi-alert-circle</v-icon></v-col>
            <v-col class="grow"><p>Mohon Maaf, Masih ada beberapa dari Anggota yang telah Anda tambahkan yang <a href="https://pusatinformasi.belajar.id/hc/id/articles/5696645239961-Panduan-Menautkan-Akun-belajar-id-Setelah-Login-Pada-Akun-SIMPKB" target="_blank">belum menautkan akun belajar.id</a> atau <span class="blue--text">telah mengikuti diklat {{current_instansi.nama}} sebelumnya </span> sebagai persyaratan pendaftaran untuk seri ini. </p>
              <p>Anda bisa berkoordinasi terlebih dahulu dengan Anggota Anda, dan berikut adalah tata cara menautkan akun belajar.id:</p>
              <ol>
                <li>Menuju tautan <a href="https://akun.simpkb.id/" target="_blank">https://akun.simpkb.id/</a></li>
                <li>Masuk menggunakan akun SIMPKB</li>
                <li>Pilih menu <strong>Integrasi Layanan</strong> dan klik <strong>Tautan</strong></li>
                <li>Masuk menggunakan <strong>Akun Belajar.id</strong> Anda</li>
                <li>selesai</li>
              </ol>
              <p class="pt-4">Terima Kasih</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end" v-if="grup.isSyaratComplete&&isNotAvailableClass">
          <v-btn text class="text-primary" @click="showConfirmationDialog = false">Nanti</v-btn>
          <v-btn @click="saveWithConfirmation(grup.isSyaratComplete)" class="primary">Daftar</v-btn>
        </v-card-actions>
        <v-card-actions class="justify-end" v-else>
        <v-btn class="primary text-white" @click="showConfirmationDialog = false">Tutup</v-btn>
      </v-card-actions>

      </v-card>
    </v-dialog>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      selectedOption: null,
      sekolah: {
        jenjang_id: null
      },
      grup: {
        leader: null,
        user1: null,
        user2: null,
        isSyaratComplete: null
      },
      itemKandidats: [],
      is_daftar: false,
      guruSelectionError: false,
      showConfirmationDialog: false,
      options: [
        {
          label: "Simpan Sebagai Draft",
          description:
            "Menyimpan sebagai draft tidak secara otomatis mendaftarkan data yang dimasukkan, hal ini dirancang untuk memperhitungkan kemungkinan perubahan anggota yang mendaftar sebelum dikonfirmasi pendaftaran"
        },
        {
          label: "Daftar Sekarang",
          description:
            "Jika Anda yakin tidak ada perubahan pada anggota yang terdaftar, pilih opsi ini. Harap dicatat bahwa setelah mendaftar data yang Anda kirim tidak dapat diubah."
        }
      ],
      isEmailBelajarUser1: null,
      isEmailBelajarUser2: null,
      isBelajarIdLeader: null,
      isNotAvailableClass: false
    };
  },
  methods: {
    open(val, statuspendaftaran) {
      this.is_daftar = statuspendaftaran ? true : false;
      this.sekolah = val;
      this.grup.leader = this.current_user.name;
      this.validateGuruSelection(this.current_user,0);
      this.loadGuru();
      let x = this.$refs.registrasiDlg.open();
      this.$validator.reset();
      return x;
    },

    validateGuruSelection(guru, index) {

      if (guru) {

        if(index==0&&this.sekolah.jenjang_id ==2){

        }else{
          this.$store
            .dispatch("user/cekSyarat", {
              instansi_id: this.instansi_id,
              paspor_id: guru.paspor_id
            })

            .then(resp => {

              const isNotAvailableClass = resp.is_daftar

              if(isNotAvailableClass){
                this.$warning(guru.nama+' telah terdaftar di Diklat '+this.current_instansi.nama+' sebelumnya')
              }

              //jika pernah ikut seri sama sebelumnya tidak dapat ikut kembali
              this.isNotAvailableClass = !isNotAvailableClass


            })
            .catch(e => {
              console.error("Error during validation:", e);
            });
        }




        const isBelajarId = index==0?guru.email_belajar_id?true:false:guru.email_belajar?true:false

        if (guru === this.grup.user1 && index==1) {
          this.isEmailBelajarUser1 = isBelajarId;
        } else if (guru === this.grup.user2  && index==2) {
          this.isEmailBelajarUser2 = isBelajarId;
        } else if (guru.nama === this.grup.leader, index==0) {
          this.isBelajarIdLeader = this.sekolah.jenjang_id == 2 ? true : isBelajarId;
        }
      }else{
        this.isNotAvailableClass = true
      }

      if (this.grup.user1 && this.grup.user2) {
        this.guruSelectionError = this.grup.user1.ptk_id && this.grup.user2.ptk_id ? this.grup.user2.ptk_id === this.grup.user1.ptk_id : false;

        if (this.guruSelectionError) {
          this.$warning("Anda tidak dapat memilih PTK yang sama");
        }
      }
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {

          this.saveDraft()

          // Setelah validasi sukses, tampilkan dialog konfirmasi
          this.showConfirmationDialog = true;
          // Set syarat daftar kelas sesuai dengan kelengkapan berkas
          if ((this.isBelajarIdLeader || !this.grup.leader) && (this.isEmailBelajarUser1 || !this.grup.user1) && (this.isEmailBelajarUser2 || !this.grup.user2)) {
            this.grup.isSyaratComplete = 1; // Set is_daftar ke 1 jika berkas leader lengkap, dan berkas user1 atau user2 lengkap atau user1 dan user2 tidak diisi
          } else {
            this.grup.isSyaratComplete = 0; // Set is_daftar ke 0 jika ada berkas yang belum lengkap
          }
        })
        .catch(e => e);
    },

    saveDraft() {
      // Set isKonfirmasi sesuai dengan pilihan dialog
      this.grup.is_daftar = 0;

      // Simpan data
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          const anggota = [];

          if (this.grup.leader && this.sekolah.jenjang_id == 1) {
            anggota.push(this.itemKandidatsKS[0]);
          }

          if (this.grup.user1) {
            anggota.push(this.grup.user1);
          }
          if (this.grup.user2) {
            anggota.push(this.grup.user2);
          }

          return this.$store.dispatch("kelas/enrollPesertaGrup", {
            instansi_id: this.instansi_id,
            anggota: anggota,
            jenjang_id: this.sekolah.jenjang_id,
            is_daftar: this.grup.is_daftar
          });
        })
        .catch(e => e);
    },

    saveWithConfirmation(isKonfirmasi) {
      // Set isKonfirmasi sesuai dengan pilihan dialog
      this.grup.is_daftar = isKonfirmasi? 1 : 0;

      // Simpan data
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          const anggota = [];

          if (this.grup.leader && this.sekolah.jenjang_id == 1) {
            anggota.push(this.itemKandidatsKS[0]);
          }

          if (this.grup.user1) {
            anggota.push(this.grup.user1);
          }
          if (this.grup.user2) {
            anggota.push(this.grup.user2);
          }

          return this.$store.dispatch("kelas/enrollPesertaGrup", {
            instansi_id: this.instansi_id,
            anggota: anggota,
            jenjang_id: this.sekolah.jenjang_id,
            is_daftar: this.grup.is_daftar
          });
        })
        .then(res => {
          this.$info("Pendaftaran berhasil diproses");
          this.isNotAvailableClass = false
          this.$refs.registrasiDlg.resolve();
          this.showConfirmationDialog = false; // Tutup dialog setelah berhasil disimpan
          return res;
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    loadGuru() {
      return this.$store
        .dispatch("user/ptk", {
          instansi_id: this.instansi_id,

          params: {}
        })
        .then(res => {
          this.itemKandidats = this.itemKandidats = res.ptk.map(ptk => ({ ...ptk, sekolah_id: res.sekolah.sekolah_id }));
          this.itemKandidatsKS = this.itemKandidats.filter(ptk => ptk.paspor_id == this.current_user.paspor_id);
          this.itemKandidats = res.ptk.filter(ptk => ptk.paspor_id !== this.current_user.paspor_id);

          // Filter anggota berdasarkan paspor_id
          const anggotaPasporIds = res.anggota.map(anggota => anggota.paspor_id);

          // Mengisi data untuk user1 dan user2 secara dinamis
          for (let i = 0; i < Math.min(anggotaPasporIds.length, 2); i++) {
            const filteredUser = this.itemKandidats.find(ptk => anggotaPasporIds[i] && ptk.paspor_id === anggotaPasporIds[i]);
            if (filteredUser) {
              this.grup[`user${i + 1}`] = filteredUser || {}; // Mengambil objek pertama atau objek kosong jika tidak ada hasil
              this.validateGuruSelection(filteredUser,i+1);
            }
          }
        })
        .catch(e => e);
    }
  }
};
</script>
